import { faSignIn } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Footer from '../../components/Layout/Footer'
import * as SETTINGS from '../../constants/settings'
import { AuthenticationContext } from '../../context/authenticationContext'
import { SiteConfigContext } from '../../context/siteConfigContext'
import Logo from '../../graphics/Logo'
import { putUser } from '../../utils/APIs/users'
import { setPageTitle } from '../../utils/utilities'

const WelcomeVideo = () => {
  setPageTitle('Welcome')
  const { user, updateUser } = useContext(AuthenticationContext)
  const {
    [SETTINGS.VIDEO.key]: videos,
    [SETTINGS.WELCOME_TEXT.key]: welcomeText
  } = useContext(SiteConfigContext)

  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'

  const hasVideo = videos && videos.welcome
  const hasText = Boolean(welcomeText)

  useEffect(() => {
    if (!hasVideo && !hasText) {
      navigate('/')
    }
  }, [hasVideo, hasText, navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!user) {
      navigate('/login')
      return
    }
    const response = await putUser(user._id, 'onboarding.welcome', true)

    if (response && response.status === 200) {
      updateUser(response.data)
      navigate(from, { replace: true })
    }
  }

  if (hasVideo && hasText) {
    return (
      <main className="flex flex-col h-screen overflow-y-auto bg-primary-gradient sm:p-2.5 gap-2.5 md:gap-5">
        <div className="h-8 md:h-12 mx-auto mt-2.5 md:mt-5">
          <Logo />
        </div>
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-3 gap-2.5 md:gap-5">
          <div className="col-span-1 lg:col-span-2 h-fit shadow-lg">
            <video controls className="w-full rounded-lg">
              <source src={videos.welcome} type="video/mp4" />
              <source src={videos.welcome} type="video/webm" />
              <source src={videos.welcome} type="video/ogg" />
              <source src={videos.welcome} type="video/quicktime" />
              <source src={videos.welcome} type="video/x-msvideo" />
              <source src={videos.welcome} type="video/x-matroska" />
              Your browser does not support the video element.
            </video>
          </div>
          <div className="col-span-1 lg:col-span-1 h-fit shadow-lg p-2.5 md:p-5 bg-white dark:bg-neutral-900 md:rounded-xl flex flex-col gap-2.5 md:gap-5">
            <h1 className="text-center md:text-left font-bold">Welcome!</h1>
            <p className="w-fit text-lg">{welcomeText}</p>
            <form onSubmit={handleSubmit} autoComplete="off">
              <button
                type="submit"
                aria-label="Submit message"
                className="button-fill my-2.5 p-2.5 flex items-center justify-center md:justify-start md:text-lg w-full md:w-fit"
              >
                Enter The Stream
                <FontAwesomeIcon icon={faSignIn} className="ml-2" />
              </button>
            </form>
          </div>
        </div>
        <div className="mt-auto">
          <Footer />
        </div>
      </main>
    )
  }

  if (hasVideo && !hasText) {
    return (
      <main className="flex flex-col h-screen overflow-y-auto bg-primary-gradient sm:p-2.5 gap-2.5 md:gap-5">
        <div className="h-8 md:h-12 mx-auto mt-2.5 md:mt-5">
          <Logo />
        </div>
        <div className="container mx-auto flex flex-col gap-2.5 md:gap-5 items-center">
          <div className="w-full max-w-4xl shadow-lg">
            <video controls className="w-full rounded-lg">
              <source src={videos.welcome} type="video/mp4" />
              <source src={videos.welcome} type="video/webm" />
              <source src={videos.welcome} type="video/ogg" />
              <source src={videos.welcome} type="video/quicktime" />
              <source src={videos.welcome} type="video/x-msvideo" />
              <source src={videos.welcome} type="video/x-matroska" />
              Your browser does not support the video element.
            </video>
          </div>
          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            className="w-full flex justify-center"
          >
            <button
              type="submit"
              aria-label="Submit message"
              className="button-fill my-2.5 p-2.5 flex items-center justify-center md:justify-start md:text-lg"
            >
              Enter The Stream
              <FontAwesomeIcon icon={faSignIn} className="ml-2" />
            </button>
          </form>
        </div>
        <div className="mt-auto">
          <Footer />
        </div>
      </main>
    )
  }

  if (!hasVideo && hasText) {
    return (
      <main className="flex flex-col h-screen overflow-y-auto bg-primary-gradient sm:p-2.5 gap-2.5 md:gap-5">
        <div className="h-8 md:h-12 mx-auto mt-2.5 md:mt-5">
          <Logo />
        </div>
        <div className="container mx-auto flex flex-col items-center justify-center flex-grow">
          <div className="w-full max-w-md shadow-lg p-2.5 md:p-5 bg-white dark:bg-neutral-900 md:rounded-xl flex flex-col gap-2.5 md:gap-5 text-center">
            <h1 className="font-bold">Welcome!</h1>
            <p className="text-lg">{welcomeText}</p>
            <form onSubmit={handleSubmit} autoComplete="off">
              <button
                type="submit"
                aria-label="Submit message"
                className="button-fill my-2.5 p-2.5 flex items-center justify-center md:text-lg w-full"
              >
                Enter The Stream
                <FontAwesomeIcon icon={faSignIn} className="ml-2" />
              </button>
            </form>
          </div>
        </div>
        <div className="mt-auto">
          <Footer />
        </div>
      </main>
    )
  }

  return null
}

export default WelcomeVideo
